import React from "react";
import Root from "./pages/Root";
import Layout from "./components/Layout";
import "assets/styles/global.scss";
import { Route, Routes } from "react-router-dom";
import Schedule from "./pages/Root/Schedule";
import Explore from "./pages/Root/Explore";

function App() {
  const [isFirstScreen, setIsFirstScreen] = React.useState(false);

  return (
    <Layout isFirstScreen={isFirstScreen}>
      <Routes>
        <Route path={'/'} element={<Root isFirstScreen={isFirstScreen} setIsFirstScreen={setIsFirstScreen} /> }/>
        <Route path={'/schedule'} element={<Schedule />} />
        <Route path={'/search'} element={<Explore />} />
      </Routes>
    </Layout>
  );
}

export default App;
